import { applyMiddleware, createStore } from 'redux'
import thunk from 'redux-thunk'
import promiseMiddleWare from 'redux-promise'
import createDebounce from 'redux-debounce'
import toastsMiddleware from './middleware/toasts'
import documentSidebar from './modules/documentSidebar'
import { IS_EMBEDDED } from 'constants/embedding'

export const INITIALIZE_APP = Symbol('INITIALIZE_APP')

const debounceConfig = {
  simple: {
    wait: 300,
    leading: true,
  },
}

export default function configureStore({
  initialState = { sidebarRightOpen: IS_EMBEDDED ? false : true },
}) {
  const middleware = applyMiddleware(
    createDebounce(debounceConfig),
    promiseMiddleWare,
    thunk,
    toastsMiddleware
  )

  const store = createStore(documentSidebar, initialState, middleware)

  return store
}
